import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import { BasePage } from 'main/components/_common/BasePage';
import { ExperienceDescription } from './ExperienceDescription';
import { Schedule } from './Schedule';
import { EventReferenceDialog } from './EventReferenceDialog';
import { EventFormDialog } from './EventFormDialog';

import { actions } from 'main/store/schedule/reducer';
import { callRestAPI } from 'main/utils/rest-apis';
import { getEvents } from 'main/utils/rest-apis/events';

export const SchedulePage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        callRestAPI(dispatch, async () => {
            const events = await getEvents();
            dispatch(actions.fetchEvents(events));
        });
    }, [dispatch]);

    return (
        <BasePage title="スケジュール">
            <Grid container direction="column">
                <Grid item>
                    <ExperienceDescription />
                </Grid>
                <Grid item>
                    <Schedule />
                </Grid>
            </Grid>
            <EventReferenceDialog />
            <EventFormDialog />
        </BasePage>
    )
}
